import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../ui/button'
import './informationWindow.sass'
// import MessageArea from '../../pages/payment/materials/MessageArea'

interface Props {
    title?: string
    informationText: string
    externalState: boolean
    setExternalState: React.Dispatch<React.SetStateAction<boolean>>
    labelFunctionalButton?: string
    functionalButtonCallback?: () => void
    closeButton?: boolean
    secondParagraph?: boolean
    thirdParagraph?: boolean
    isJustify?: boolean
    // textAreaValue?: string
    // setTextareaValue?: React.Dispatch<string>
    // withTextArea?: boolean
    // isError?: boolean
    showCloseIcon?: boolean
}

const InformationWindow: React.FunctionComponent<Props> = ({
    title,
    informationText,
    externalState,
    setExternalState,
    labelFunctionalButton,
    closeButton,
    functionalButtonCallback = () => {
        setExternalState(false)
    },
    secondParagraph,
    thirdParagraph,
    isJustify,
    // textAreaValue,
    // setTextareaValue,
    // withTextArea,
    // isError,
    showCloseIcon = true
}: Props) => {
    const [t] = useTranslation()

    return externalState ? (
        <div
            data-testid={'informationPopup'}
            className="informationWrapper"
            onClick={() => {
                setExternalState(false)
            }}
        >
            {showCloseIcon && <div className="closeButton"></div>}
            <div className="informationPopup" onClick={(event) => event.stopPropagation()}>
                <p className="informationTitle">{title || t('Information')}</p>
                <p
                    className={isJustify ? 'informationText_justify' : 'informationText'}
                    dangerouslySetInnerHTML={{ __html: informationText || t('Something went wrong') }}
                >
                    {/*{informationText || t('Something went wrong')}*/}
                </p>
                {secondParagraph && (
                    <p className={isJustify ? 'informationText_justify' : 'informationText'}>{secondParagraph}</p>
                )}
                {thirdParagraph && (
                    <p className={isJustify ? 'informationText_justify' : 'informationText'}>{thirdParagraph}</p>
                )}
                {/*{withTextArea ? (*/}
                {/*    <>*/}
                {/*        <MessageArea*/}
                {/*            externalState={textAreaValue}*/}
                {/*            setExternalState={setTextareaValue}*/}
                {/*            label={t('Describe the reason for deleting your account')}*/}
                {/*        />*/}
                {/*        {isError ? <p className="errorInformationWindow">{t('Reason is required')}</p> : <></>}*/}
                {/*    </>*/}
                {/*) : (*/}
                {/*    <></>*/}
                {/*)}*/}
                <div className={'dialogButtonGroup'}>
                    {labelFunctionalButton && (
                        <Button label={labelFunctionalButton} onClick={functionalButtonCallback} />
                    )}
                    {closeButton && <Button label={t('Cancel')} secondary onClick={() => setExternalState(false)} />}
                </div>
            </div>
        </div>
    ) : (
        <></>
    )
}

export default InformationWindow
